<ion-grid style='background: transparent; margin-top:40%'>
  <ion-row class="ion-center">
    <ion-col class="ion-text-center">
      <div>
        {{message}}
        <ion-spinner name='crescent' color='primary'></ion-spinner>
      </div>
    </ion-col>
  </ion-row>
</ion-grid>